module.exports = __webpack_public_path__ + "1_0_57/img/200 Eiffel Tower.24374a40.jpg";